import React from "react";

function ProductPricing({ ProductPrice }) {
  return <>₹{Number(ProductPrice).toFixed(0)}</>;
}

export default ProductPricing;
